import {
  CheckCircle,
  Loader,
  Calendar,
  AlertCircle,
  XCircle,
} from "lucide-react";

export const TOAST_MESSAGES = {
  SITES_FETCH_FAILED: "Failed To Load Sites..",
  SITES_CREATED: "Site created successfully",
  SITES_CREATION_FAILED: "Site creation failed",
  SITES_CREATION_ERROR: "An error occurred while creating the Site",
  SITES_GET_DETAILS_ERROR: "An error occurred while fetching Site details",
  SITES_DETAILS_FETCHED: "Site details fetched successfully",
  USER_FETCH_FAILED: "Failed To Load users..",
  TASK_FETCH_FAILED: "Failed To Load Task..",
  TASK_ADD_FAILED: "Failed to add task.",
  TASKS_FETCHED: "Tasks fetched successfully",
  FAILED_TO_UPDATE_TASK: "Failed to update task",
  COMMENT_ADD_FAILED: "Failed to add comment",
  COMMENT_FETCH_FAILED: "Failed to fetch comments",
  FAILED_FETCH_FILE: "Failed to fetch files.",
  ERROR_FETCH_FILE: "Error fetching files!",
  FAILED_DELETE_FILE: "Failed to delete file.",
  FAILED_UPLOAD_FILE: "Failed to upload file.",
  FILE_UPLOADED: "File Uploaded Successfully.",
  FILE_DELETED: "File deleted Successfully.",
  SITE_DETAILS_FAILED: "Failed to Load Site details!",
  UPDATE_SITE_DETAILS_SUCCESS: "Updated Site details Successfully.",
  UPDATE_SITE_DETAILS_FAILED: "Failed to Update Site details!",
  UPDATE_SITE_DETAILS_ERROR: "Error Updating Site details!",
  USERS_UPLOAD_SUCCESS: "Users Uploaded Successfully.",
  USERS_UPLOAD_FAILED: "Failed to Upload Users!",
  USERS_UPLOAD_ERROR: "Error Uploading Users!",
  USERS_UPLOAD_PARTIAL: "Some users are not uploaded!",
  USERS_DELETE_SUCCESS: "Users deleted successfully",
  USERS_DELETE_PARTIAL: "Selected users are deleted successfully",
  USERS_DELETE_FAILED: "Failed to delete users!",
  USERS_DELETE_ERROR: "Error deleting users!",
  USER_DELETE_SUCCESS: "User Deleted Successfully.",
  USER_DELETE_FAILED: "Failed to Delete User!",
  USER_DELETE_ERROR: "Error Deleting User!",
  USER_UPDATION_SUCCESS: "User Updated Successfully.",
  USER_UPDATION_FAILED: "Failed to Update User!",
  USER_UPDATION_ERROR: "Error Updating User!",
  PROJECT_DETAILS_FETCH_ERROR: "Failed to fetch project details",
  TASK_FILE_DELETE_ALERT: "Are you sure you want to delete this task file?",
  POLYGON_PATH_ERROR: "Please draw a valid polygon with at least 3 points.",
  SITE_FILE_DELETE_ALERT: "Are you sure you want to delete this site file?",
  DOWNLOAD_EXCEL_FAILED: "Failed to download sample excel"

};

export const MESSAGES = {
  NO_SITE_FOUND: "No Sites Found",
  NO_TASKS_FOUND: "No Site Task Found",
  NO_COMMENTS: "Currently, there are no comments associated with this task.",
  NOT_ASSIGNED_YET: "Not assigned yet",
  NO_TASKS_AVAILABLE: "No Tasks Available",
  NOT_SET: "not set",
  GEOFENCE_ERROR: "Failed to parse geofence:",
  NO_FILES_AVAILABLE: " No files uploaded yet.",
  ALL_FILES_LOADED: "All files loaded.",
  NO_SUB_TASKS: "No sub-tasks available."
};

export const SITE_LIST_COLUMNS = [
  "site_name",
  "state",
  "region",
  "zone",
  "district",
  "status",
  "completion_percentage",
];

export const SITE_COLUMNS_LABELS = {
  site_name: "Name",
  state: "State",
  region: "Region",
  zone: "Zone",
  district: "District",
  status: "Status",
  completion_percentage: "Completion (%)",
};

export const TASKS_LIST_PAGE_COLUMNS = [
  "site_name",
  "title",
  "order",
  "weight",
  "assigned_to",
  "status",
  "actions",
];

export const TASKS_LIST_PAGE_LABELS = {
  site_name: "Site Name",
  title: "Title",
  order: "Order",
  weight: "Weight",
  assigned_to: "Assigned To",
  status: "Status",
  actions: "Action",
};

export const TASK_ACTIONS = {
  START: "start",
  APPROVE: "approved",
  REJECT: "rejected",
  SUBMIT: "submit",
  MAKE_PENDING: "Mark as Pending",
};

export const TABS = {
  DETAILS: "DETAILS",
  COMMENTS: "COMMENTS",
  ATTACHMENTS: "ATTACHMENTS",
  ACTIVITY: "ACTIVITY",
  TASKS: "TASKS",
  FILES: "FILES",
};

export const TASK_STATUS = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  PENDING_L1_APPROVAL: "PENDING_L1_APPROVAL",
  CANCELLED: "CANCELLED",
  CLOSED: "CLOSED",
  COMPLETED: "COMPLETED",
};

export const TASK_STATUS_LABELS = {
  PENDING: "Pending",
  IN_PROGRESS: "In Progress",
  PENDING_L1_APPROVAL: "Pending L1 Approval",
  CANCELLED: "Cancelled",
  CLOSED: "Closed",
  COMPLETED: "Completed",
  UPCOMING: "Upcoming",
};

export const TASK_STATUS_MAPPING = [
  { value: "", label: "All" },
  ...Object.keys(TASK_STATUS).map((key) => ({
    value: TASK_STATUS[key],
    label: TASK_STATUS_LABELS[key],
  })),
];

export function getStatusIconAndColor(status) {
  switch (status) {
    case TASK_STATUS.COMPLETED:
      return {
        icon: <CheckCircle size={14} className="text-green-600" />,
        color: "bg-green-200",
      };
    case TASK_STATUS.IN_PROGRESS:
      return {
        icon: <Loader size={14} className="text-blue-600" />,
        color: "bg-blue-200",
      };
    case TASK_STATUS.PENDING:
      return {
        icon: <Calendar size={14} className="text-gray-600" />,
        color: "bg-gray-200",
      };
    case TASK_STATUS.PENDING_L1_APPROVAL:
      return {
        icon: <AlertCircle size={14} className="text-yellow-600" />,
        color: "bg-yellow-200",
      };
    case TASK_STATUS.CANCELLED:
      return {
        icon: <XCircle size={14} className="text-red-600" />,
        color: "bg-red-200",
      };
    case TASK_STATUS.CLOSED:
      return {
        icon: <CheckCircle size={14} className="text-purple-600" />,
        color: "bg-purple-200",
      };
    default:
      return {
        icon: <Calendar size={14} className="text-gray-600" />,
        color: "bg-gray-200",
      };
  }
}

export const SITE_TABS = [
  { key: TABS.DETAILS, label: "Details" },
  { key: TABS.USERS, label: "Users" },
  { key: TABS.TASKS, label: "Tasks" },
  { key: TABS.FILES, label: "Files" },
];

export const SITE_STATUS = [
  {
    value: "PENDING",
    label: "Not Started",
    style: "bg-yellow-100 text-yellow-700",
  },
  {
    value: "IN_PROGRESS",
    label: "In Progress",
    style: "bg-blue-100 text-blue-700",
  },
  {
    value: "COMPLETED",
    label: "Completed",
    style: "bg-green-100 text-green-700",
  },
];

export const SITE_STATUS_LABELS = SITE_STATUS.reduce((acc, s) => {
  acc[s.value] = s.label;
  return acc;
}, {});

export const SITE_STATUS_STYLES = SITE_STATUS.reduce(
  (acc, s) => {
    acc[s.value] = s.style;
    return acc;
  },
  { default: "bg-red-100 text-red-700" }
);
